import React from 'react';
import { Play, ExternalLink, Facebook } from 'lucide-react';
import { videoHighlights } from '../data/mock';

export default function VideoSection() {
  return (
    <section className="py-20 bg-navy">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="section-title centered text-4xl md:text-5xl">Video & Highlights</h2>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            Guarda il video di presentazione della XIV edizione e rivivi i momenti più belli
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videoHighlights.map((v) => (
            <VideoCard key={v.id} v={v} />
          ))}
        </div>
      </div>
    </section>
  );
}

function VideoCard({ v }) {
  const [playing, setPlaying] = React.useState(false);

  if (v.type === 'video') {
    return (
      <div className="group glass-card overflow-hidden">
        <div className="relative aspect-video overflow-hidden bg-black">
          {playing ? (
            <video
              src={v.videoUrl}
              controls
              autoPlay
              className="w-full h-full object-cover"
            />
          ) : (
            <>
              <img
                src={v.thumbnail}
                alt={v.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-transparent to-transparent"></div>
              <button
                onClick={() => setPlaying(true)}
                className="absolute inset-0 flex items-center justify-center"
                aria-label="Riproduci video"
              >
                <div className="w-16 h-16 rounded-full bg-pink-brand flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg animate-pulse-glow">
                  <Play size={26} className="text-white ml-1" fill="white" />
                </div>
              </button>
              <span className="absolute top-3 right-3 bg-pink-brand backdrop-blur text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-widest">
                XIV · 2026
              </span>
            </>
          )}
        </div>
        <div className="p-5">
          <h3 className="text-white font-bold text-base mb-2">{v.title}</h3>
          <p className="text-white/70 text-sm line-clamp-2">{v.description}</p>
        </div>
      </div>
    );
  }

  return (
    <a
      href={v.facebookUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group glass-card overflow-hidden block"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={v.thumbnail}
          alt={v.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-transparent to-transparent"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-pink-brand flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
            <Play size={26} className="text-white ml-1" fill="white" />
          </div>
        </div>
        <span className="absolute top-3 right-3 bg-[#1877F2] backdrop-blur text-white text-[10px] font-bold px-2 py-1 rounded flex items-center gap-1">
          <Facebook size={10} /> FACEBOOK
        </span>
      </div>
      <div className="p-5">
        <h3 className="text-white font-bold text-base mb-2 group-hover:text-pink-brand transition-colors">
          {v.title}
        </h3>
        <p className="text-white/70 text-sm line-clamp-2">{v.description}</p>
        <div className="mt-3 flex items-center gap-2 text-pink-brand text-xs font-semibold">
          Guarda su Facebook <ExternalLink size={12} />
        </div>
      </div>
    </a>
  );
}
